// Top Secret Garage - Shopify Theme JavaScript

document.addEventListener('DOMContentLoaded', function() {
  console.log('Top Secret Garage theme loaded');

  // Mobile menu toggle
  const menuToggle = document.querySelector('.menu-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function() {
      mobileMenu.classList.toggle('active');
    });
  }

  // Cart notification
  const cartForm = document.querySelector('form[action="/cart/add"]');
  if (cartForm) {
    cartForm.addEventListener('submit', function(e) {
      // You can add custom cart notification here
      console.log('Product added to cart');
    });
  }

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const href = this.getAttribute('href');
      if (href !== '#') {
        e.preventDefault();
        const target = document.querySelector(href);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth' });
        }
      }
    });
  });

  // Product image gallery
  const productImages = document.querySelectorAll('.product-image img');
  productImages.forEach(img => {
    img.addEventListener('click', function() {
      // Open lightbox or expand image
      console.log('Image clicked:', this.src);
    });
  });

  // Add to cart quantity validation
  const quantityInputs = document.querySelectorAll('input[name="quantity"]');
  quantityInputs.forEach(input => {
    input.addEventListener('change', function() {
      const value = parseInt(this.value);
      if (value < 1) {
        this.value = 1;
      }
    });
  });
});

// Utility function to format currency
function formatCurrency(amount) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(amount);
}

// Utility function to add to cart
function addToCart(productId, quantity = 1) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      items: [{
        id: productId,
        quantity: quantity
      }]
    })
  })
  .then(response => response.json())
  .then(data => {
    console.log('Added to cart:', data);
    // Update cart count or show notification
  })
  .catch(error => console.error('Error:', error));
}

// Utility function to update cart
function updateCart(lineItemId, quantity) {
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      updates: {
        [lineItemId]: quantity
      }
    })
  })
  .then(response => response.json())
  .then(data => {
    console.log('Cart updated:', data);
  })
  .catch(error => console.error('Error:', error));
}
